import React from 'react';
import MyPharmacyLogo from 'assets/mypharmacy-logo.svg';
import styled from 'styled-components';

type LogoProps = {
  maxWidth?: number;
};

export const StyledImg = styled.img<LogoProps>`
  ${props => props.maxWidth && `max-width: ${props.maxWidth}px;`}
`;

export default (props: LogoProps) => <StyledImg {...props} src={MyPharmacyLogo} alt="MyPharmacy Logo" />;
